export default {
  project: "Project",
  projectList: "Projects",
  code: "Code",
  name: "Name",
  description: "Description",
  client: "Client",
  createClient: "Create a new client",
  refreshClients: "Refresh client list",
  startDate: "Start Date",
  start_date: "Start Date",
  endDate: "End Date",
  end_date: "End Date",
  members: "Members",
  createNewProject: "Create Project",
  successfulProjectUpdate: "Project updated successfully",
  deleteSuccess: "Project deleted successfully",
  confirmDeleteTitle: "Delete Project",
  confirmDeleteTitle_plural: "Delete Projects",
  confirmDeleteMessage: "Are you sure you want to delete this project?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} projects?",
  deleteError:
    "Sorry, this project could not be deleted due to an error on our end. Please try again later.",
  projectType: "Project Type",
  typeHourly: "Hourly",
  typeFixed: "Fixed",
  budget: "Budget",
  totalHours: "Total Hours",
  billableHours: "Billable Hours",
  invoiced: "Invoiced",
  paid: "Paid",
  uninvoiced: "Uninvoiced",
  budgetUtilization: "Budget",
  hourlyRate: "Hourly Rate",
  memberRate: "Member Rate",
  memberRateDescription:
    "Rates here take priority. If empty, the project's hourly rate is used. If the project has no rate, the member's base rate applies.",
  memberRatePlaceholderProject: "Project rate: {{rate}}/hr",
  memberRatePlaceholderBase: "Base rate: {{rate}}/hr",
  lockedUntil: "Lock entries until",
  lockConfirmTitle: "Lock Time Entries",
  lockConfirmMessage:
    "All time entries on or before {{date}} will be locked. Members and contributors won't be able to edit or delete them.",
  enableServices: "Enable Services",
  services: "Services",
  addService: "Add Service",
  removeService: "Remove Service",
  serviceRate: "Service Rate",
  serviceDefaultRate: "Default: {{rate}}/hr",
  serviceRateOverride: "Service Rate (/hr)",
  serviceMemberRate: "Member Service Rate (/hr)",
  serviceMemberRateDescription:
    "Override the rate for this member on this service. If empty, the rate chain fallback applies.",
  addMember: "Add Member",
  removeMember: "Remove",
  billable: "Billable",
  nonBillable: "Non-billable",
  confirmRemoveServiceTitle: "Remove Service",
  confirmRemoveServiceMessage:
    "This service has {{count}} member(s) assigned. Removing it will unassign them.",
  confirmRemoveServiceMessageNoMembers:
    "Are you sure you want to remove this service from the project?",
  confirmRemoveMemberTitle: "Remove member",
  confirmRemoveMemberMessage:
    "Remove {{name}} from this service? You can re-add them later.",
  switchToNonServiceWarning:
    "Switching to non-service mode will deactivate service-based member assignments. You'll need to add members directly.",
  confirmSwitchModeTitle: "Disable Services",
  noServicesAttached: "No services attached. Add a service to assign members.",
  selectService: "Select a service...",
  selectMember: "Select a member...",
  manageServices: "Manage services",
  refreshServices: "Refresh service list",
};
